import { getDBIdFromGraphqlId } from 'src/utils/commonFunctions';

export const getTotalFees = async (fund, className, client, date) => {
  try {
    const fundId = fund ? getDBIdFromGraphqlId(fund).toString() : null;
    const clientId = client ? getDBIdFromGraphqlId(client).toString() : null;

    const params = new URLSearchParams();

    if (fundId) params.append('fundUuid', fundId);
    if (className) params.append('className', className);
    if (clientId) params.append('investorUuid', clientId);
    if (date) {
      const [day, month, year] = date.split('/').map(Number);
      const dateObj = new Date(year, month - 1, day);

      if (fundId === '35') {
        dateObj.setMonth(dateObj.getMonth() - 6);
      }

      const adjustedYear = dateObj.getFullYear();
      const adjustedMonth = String(dateObj.getMonth() + 1).padStart(2, '0');
      const adjustedDay = String(dateObj.getDate()).padStart(2, '0');

      params.append(
        'dateUntil',
        `${adjustedYear}-${adjustedMonth}-${adjustedDay}`,
      );
    }

    // const ropUrl = `${process.env.REACT_APP_ROP_MOVEMENTS_URL}/tir-report?${params}`;

    // const response = await fetch(ropUrl, {
    //   method: 'GET',
    //   headers: {
    //     'x-token': `${process.env.REACT_APP_ROP_TOKEN}`,
    //     'x-api-key': `${process.env.REACT_APP_ROP_APIKEY}`,
    //   },
    // });

    // if (!response.ok) {
    //   throw new Error(`Connection failed: ${response.statusText}`);
    // }

    // const data = await response.json();
    // return data?.investors?.[0]?.totalFees ?? 0;
    return 0;
  } catch (error) {
    console.error('Error getting total fees:', error);
    throw error;
  }
};
